module.exports = __webpack_public_path__ + "images/emoji/sagittarius.05f9cea02091278dda0c.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/sagittarius.png
// module id = 5ewa
// module chunks = 14